import Axios from 'axios'
import { TokenHelper } from './token-helper'

let initialized = false

export function UseAxios (router) {
  if (!initialized) {
    Axios.interceptors.request.use((config) => {
      if (!config.headers['Authorization']) { // append authorization header
        let bearerToken = TokenHelper.getBearerToken()

        if (bearerToken.Authorization) { Object.assign(config.headers, bearerToken) }
      }
      // get 请求增加时间戳
      if (config.method === 'get') {
        if (config.url.indexOf('?') === -1) {
          config.url += '?random=' + new Date().getTime()
        } else {
          config.url += '&random=' + new Date().getTime()
        }
      }
      if (!config.maxRedirects || config.maxRedirects === 5) // ensure axios does not follow redirects, so custom response interceptor below can push to app login page
      { config.maxRedirects = 0 }

      return config
    })

    Axios.interceptors.response.use(
      (response) => {
        if (response) {
          if (response.status === 200) {
            return Promise.resolve(response)
          } else {
            return Promise.reject(response)
          }
        }
      },
      (error) => {
        if (error.response.status) {
          switch (error.response.status) {
            case 401:
              let location = error.response.headers['location'] || error.response.headers['Location']
              if (location) {
                let redirectTo = '/' + location
                window.setTimeout(() => router.replace(redirectTo), 200)
              }
              break
          }
        }
        return Promise.reject(error.response)
      }
    )

    initialized = true
  }
};



// WEBPACK FOOTER //
// ./src/common/axiosuse.js